export const WEB_ANALYTICS_CONSENT_STORAGE_KEY = 'analytics_consent'
export const WEB_ANALYTICS_CONSENT_META_STORAGE_KEY = 'analytics_consent_meta'
export const WEB_ANALYTICS_CONSENT_GRANTED = 'granted'
export const WEB_ANALYTICS_CONSENT_DENIED = 'denied'
export const WEB_ANALYTICS_CONSENT_VERSION = '2026-04-privacy-v1'

export type WebAnalyticsConsentValue =
  | typeof WEB_ANALYTICS_CONSENT_GRANTED
  | typeof WEB_ANALYTICS_CONSENT_DENIED
  | null
